import loadable from '@loadable/component';
import { graphql } from 'gatsby';
import React from 'react';
// Sections that are bundled with the main bundle
import SliderSection from '../../sections/SliderSection/SliderSection';
import HeroSection from '../../sections/HeroSection/HeroSection';
import BodySection from '../../sections/BodySection/BodySection';
import GridSection from '../../sections/GridSection/GridSection';
import InfoLightSection from '../../sections/InfoLightSection/InfoLightSection';
import InfoDarkSection from '../../sections/InfoDarkSection/InfoDarkSection';
import VersusHeroSection from '../../sections/VersusHeroSection/VersusHeroSection';
import FAQSection from '../../sections/FAQSection/FAQSection';
import FormSection from '../../sections/FormSection/FormSection';
import PricingCards from '../../sections/PricingCards/PricingCards';
import IntegrationsSection from '../../sections/IntegrationsSection/IntegrationsSection';
import FeaturedPostsSection from '../../sections/FeaturedPostsSection/FeaturedPostsSection';
import CompareSection from '../../sections/CompareSection/CompareSection';
import RequestDemoHeroSection from '../../sections/RequestDemoHeroSection/RequestDemoHeroSection';
import SurveyReportSection from '../../sections/SurveyReportSection/SurveyReportSection';
import BackToSection from '../../sections/BackToSection/BackToSection';
import CostCalculatorSection from '../../sections/CostCalculatorSection/CostCalculatorSection';
import AddonsSection from '../../sections/AddonsSection/AddonsSection';
import DownloadFormSection from '../../sections/DownloadFormSection/DownloadFormSection';

// sections that are lazy-loaded
const LogosSection = loadable(
    () => import('../../sections/LogosSection/LogosSection')
);
const TimerSection = loadable(
    () => import('../../sections/TimerSection/TimerSection')
);

const sectionsComponentMapper = {
    PrismicHeroDefault: {
        component: HeroSection,
    },
    PrismicSectionDataBodySliderSection: {
        component: SliderSection,
    },
    PrismicLogosSectionDefault: {
        component: LogosSection,
    },
    PrismicTimerCarouselDefault: {
        component: TimerSection,
    },
    PrismicSplitDefault: {
        component: BodySection,
    },
    PrismicFeatureListDefault: {
        component: GridSection,
    },
    PrismicInfoDefault: {
        component: InfoLightSection,
    },
    PrismicSectionDataBodyInfoDarkSection: {
        component: InfoDarkSection,
    },
    PrismicSectionDataBodyFeaturedPosts: {
        component: FeaturedPostsSection,
    },
    PrismicSectionDataBodyComparePlanSection: {
        component: CompareSection,
    },
    PrismicSectionDataBodyVersusHeroSection: {
        component: VersusHeroSection,
    },
    PrismicFaqDefault: {
        component: FAQSection,
    },
    PrismicSectionDataBodyFormSection: {
        component: FormSection,
    },
    PrismicPricingDefault: {
        component: PricingCards,
    },
    PrismicSectionDataBodyFilterCards: {
        component: IntegrationsSection,
    },
    PrismicFormDefault: {
        component: RequestDemoHeroSection,
    },
    PrismicSectionDataBodySurveyReportSection: {
        component: SurveyReportSection,
    },
    PrismicSectionDataBodyBackToSection: {
        component: BackToSection,
    },
    PrismicSectionDataBodyCostCalculator: {
        component: CostCalculatorSection,
    },
    PrismicSectionDataBodyAddOns: {
        component: AddonsSection,
    },
    PrismicSectionDataBodyDownloadSection: {
        component: DownloadFormSection,
    },
};

export default function SectionSlots({
    sections,
    location = null,
    Wrapper = React.Fragment,
}) {
    return (
        <>
            {sections.map(({ section }, i) => {
                const data = section?.document?.data || section?.data;
                const body = data.body[0];
                if (!data || !sectionsComponentMapper[body.__typename])
                    return null;
                const styling = {
                    backgroundVariant: data?.background || 'neutral.white',
                    backgroundGradient: data?.css_gradient || null,
                    sectionTheme: data?.theme || 'default',
                    isDark:
                        data?.is_dark !== undefined || data?.is_dark !== null
                            ? data?.is_dark
                            : false,
                };
                const sectionProps = {
                    key: i,
                    data: body,
                    styling,
                    badges: data?.badges,
                    id: section?.document?.uid,
                    location,
                };
                const SectionComponent =
                    sectionsComponentMapper[body.__typename]?.component || null;

                return (
                    // Added `Wrapper` to wrap it with `DevSection` component in `$__schema` page
                    <Wrapper
                        // @ts-expect-error
                        section={section}
                        sectionProps={sectionProps}
                        SectionComponent={SectionComponent}
                    >
                        <SectionComponent {...sectionProps} />
                    </Wrapper>
                );
            })}
        </>
    );
}

export const _ = graphql`
    fragment SECTIONS_FRAGMENT on PrismicSection {
        uid
        data {
            body {
                __typename
                ...HERO_SECTION
                ...LOGOS_SECTION
                ...TIMER_SECTION
                ...BODY_SECTION
                ...GRID_SECTION
                ...SLIDER_SECTION
                ...INFO_LIGHT_SECTION
                ...INFO_DARK_SECTION
                ...FEATURED_POSTS
                ...VERSUS_HERO_SECTION
                ...PRICING_SECTION
                ...COMPARE_PLAN_SECTION
                ...FILTER_CARDS
                ...FAQ
                ...FORM_SECTION
                ...REQUEST_DEMO_HERO_SECTION
                ...SURVEY_REPORT_SECTION
                ...BACK_TO_SECTION
                ...COST_CALCULATOR_SECTION
                ...ADDONS_SECTION
                ...DOWNLOAD_FORM_SECTION
            }
            background
            is_dark
            css_gradient
            theme
        }
    }
`;
